// Simple in-memory selection store to persist choices across remounts (e.g., during streaming re-parses)

type SelectionRecord = {
    selectedChoices: string[];
    otherSelectedValue?: string;
};

const selectionMap = new Map<string, SelectionRecord>();

export function getSelectionForQuestion(key: string): SelectionRecord | undefined {
    return selectionMap.get(key);
}

export function setSelectionForQuestion(key: string, record: SelectionRecord): void {
    selectionMap.set(key, {
        selectedChoices: Array.isArray(record.selectedChoices) ? record.selectedChoices.slice() : [],
        otherSelectedValue: record.otherSelectedValue || ""
    });
}

export function clearSelectionForQuestion(key: string): void {
    selectionMap.delete(key);
}

export function clearAllSelections(): void {
    selectionMap.clear();
}
